<template>
  <el-table
      :data="transactionList"
      style="width: 100%"
      class="statement-table"
  >
    <el-table-column
      prop="date"
      label="Transaction Date"
      :formatter="getDate"
      min-width="100px"
    />
    <el-table-column
      prop="transfer_type_name"
      label="Transfer Type"
      min-width="80px"
    />
    <el-table-column
      prop="transfer_number"
      label="Transaction ID"
      min-width="100px"
    />
    <el-table-column
      prop="reference"
      label="Description"
      min-width="100px"
    />
    <el-table-column
      prop="debit"
      label="Debit"
      align="center"
    />
    <el-table-column
      prop="credit"
      label="Credit"
      align="center"
    />
    <el-table-column
      prop="balance"
      label="Balance"
      :formatter="getBalanceCell"
    />
    <el-table-column
      prop="status_name"
      label="Status"
      min-width="100px"
    />
  </el-table>
</template>

<script>

import moment from 'moment'

export default {
  props: {
    transactionList: Array,
  },

  methods: {
    getDate(row, column, cellValue) {
      return moment(cellValue).format('YYYY-MM-DD')
    },

    getBalanceCell(row) {
      return `${row.balance} (${row.currency_abbreviation})`
    },
  },
}
</script>

<style lang="scss" scoped>
  .statement-table {
    overflow-x: hidden;
  }
</style>
